export const apiPrefix = '/api/partner/outside/platform'
export const apiReportPrefix = '/api/ops/partner'
export const apiBasic = '/api/basic/partnerorder/storeout'
